import { Box, styled, Text, useTheme } from '@ltvco/refresh-lib/theme';
import {
  NeighborhoodSmartInsights,
  SearchPropertyAIForm,
} from '@ltvco/refresh-lib/v2';
import { MapRounded } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useQueryParams } from 'utils/useQueryParams';

import RecentSearchSuggestions from './RecentSearchSuggestions';

const TextWithIcon = styled(Text)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(4.5),

  svg: {
    marginRight: theme.spacing(1),
  },
}));

export const NeighborhoodReportSection = () => {
  /////////////////////////////
  // States
  /////////////////////////////
  const [address, setAddress] = useState('');

  /////////////////////////////
  // Hooks
  /////////////////////////////
  const queryParams = useQueryParams();
  const navigate = useNavigate();
  const theme = useTheme();

  /////////////////////////////
  // Event Handlers
  /////////////////////////////
  const handleAISearch = (inputAddress: string) => {
    if (inputAddress && inputAddress.trim()) {
      const trimmedAddress = inputAddress.trim();

      // Update queryParams in URL
      const newParams = new URLSearchParams(window.location.search);
      newParams.set('address', trimmedAddress);
      navigate({ search: newParams.toString() });
      setAddress(trimmedAddress);
    }
  };

  const handleSuggestionClick = (suggestionAddress: string) => {
    handleAISearch(suggestionAddress);
  };

  /////////////////////////////
  // Lifecycle Functions
  /////////////////////////////

  // On mount, check for address in queryParams
  useEffect(() => {
    const qpAddress = queryParams.get('address') || '';
    if (qpAddress && qpAddress !== address) {
      setAddress(qpAddress);
    }
  }, [queryParams, address]);

  useEffect(() => {
    document.title = 'Neighborhood Report - BeenVerified';
  }, []);

  return (
    <>
      <Box>
        <TextWithIcon variant="h1">
          <MapRounded
            sx={{ color: theme.palette.primary.main, fontSize: '2.5rem' }}
          />
          Neighborhood Report
        </TextWithIcon>
        <Box>
          <Text variant="h2" sx={{ mb: 4 }}>
            Look Up Neighborhood Insights for other locations!
          </Text>
        </Box>
      </Box>
      <SearchPropertyAIForm onSubmit={handleAISearch} />
      <RecentSearchSuggestions
        currentSearchAddress={address}
        onSuggestionClick={handleSuggestionClick}
      />
      <NeighborhoodSmartInsights address={address} />
    </>
  );
};
